import { Block } from '@attom';

import CS from './Button.module.scss';

export const Button = ({
	// box control
	boxClass = '',
	boxSpace = '',
	boxSize = '',
	// element control
	elClass = '',
	elSpace = 'py-10px px-20px',
	color = 'base', // colorsList in (framework && styles)
	icon = null,
	// custom props
	content = '', // string or function,
	loading = null,
	onClick = null,
	disabled = null,
	inlineBlock = null,

	...props
}) => {
	// return jsx

	return (
		<Block boxClass={boxClass} boxSize={boxSize} boxSpace={boxSpace} inlineBlock={inlineBlock}>
			<button
				className={`${CS.button} ${elClass} ${elSpace} `}
				_color={color}
				onClick={loading ? null : onClick}
				disabled={loading || disabled}
				_display={inlineBlock ? 'inline-block' : 'block'}
				{...props}
			>
				{loading ? (
					<i className='fa fa-spinner fa-lg fa-pulse fa-spin' />
				) : (
					<span className={CS.content}>
						{icon && typeof icon === 'function' && icon()}
						{typeof content === 'function' ? content() : content}
					</span>
				)}
			</button>
		</Block>
	);
};
